import { WordToKlankConverter } from '../../utils/klank.utils';

export class KlankGenerator {
  private seen: string[] = [];
  private oldKlank: string | undefined = undefined;

  private get correctKlank() {
    return this.word[this.index];
  }

  public constructor(
    private readonly word: string[],
    private readonly index: number,
  ) {
    this.seen.push(this.correctKlank);
  }

  getNext() {
    const chanceToGetCorrectKlank = this.oldKlank ? 0.35 : 0; // 35% chance to get the correct klank
    const shouldShowCorrectKlank = this.oldKlank !== this.correctKlank && (this.seen.length > 3 || Math.random() < chanceToGetCorrectKlank);

    let candidate: string;

    if (shouldShowCorrectKlank) {
      candidate = this.correctKlank;
    } else {
      const exclude = this.index === this.word.length - 1 ? ['v', 'c', 'z'] : []; // avoid illegal letters at the end

      let newKlank = WordToKlankConverter.getKlankVariantsFor(this.word[this.index], 1, [...exclude, ...this.seen])[0];
      if (!newKlank) {
        this.seen = []; // reset seen klanken if no similar klank found
      }
      newKlank = WordToKlankConverter.getKlankVariantsFor(this.word[this.index], 1, [...exclude])[0] ?? this.correctKlank;
      candidate = newKlank;
    }

    if (candidate === this.oldKlank) {
      candidate = this.correctKlank;
    }

    this.oldKlank = candidate;
    this.seen.push(candidate);

    return candidate;
  }
}
